import type { Category } from "@/lib/types";

/**
 * ZH-CN Ingredient → Category Dictionary
 *
 * Contains ONLY singular base forms without quantities or containers.
 * Examples: "chicken", "corn", "salsa" (not "2 lbs chicken", "bag of corn", "jar of salsa")
 *
 * The algorithm handles:
 * - Pluralization (beans → bean)
 * - Quantity stripping (2 lbs → removed)
 * - Container removal (jar of → removed)
 *
 * Generated from test data.
 * Total entries: 2387
 */

export const zhCNDictionary: Record<string, Category> = {
  "8424西瓜": "fruit", // watermelon variety
  t骨牛排: "meat",
  xo酱: "other",
  一打鸡蛋: "dairy",
  丁香: "other",
  七星椒: "produce",
  三华李: "fruit",
  三文鱼: "seafood",
  三文鱼片: "seafood",
  三明治: "other",
  三明治面包: "other",
  三鲜肉馅: "meat",
  三鲜饺子: "other",
  三黄鸡: "meat",
  上海青: "produce",
  不知火: "fruit",
  丑八怪: "fruit",
  丑橘: "fruit",
  东北酸菜: "other",
  东魁杨梅: "fruit",
  丝瓜: "produce",
  丝瓜络: "other",
  丝瓜花: "produce",
  丝瓜苗: "produce",
  中国南瓜: "produce",
  中国芹: "produce",
  中国茄子: "produce",
  中国黄瓜: "produce",
  中筋面粉: "other",
  中虾: "seafood",
  丰水梨: "fruit",
  丹麦面包: "other",
  乌冬面: "other",
  乌梅: "other",
  乌贼: "seafood",
  乌鱼: "seafood",
  乌鸡: "meat",
  乌龙茶: "other",
  九孔鲍: "seafood",
  九层塔: "produce",
  九节虾: "seafood",
  乳清: "dairy",
  乳清蛋白: "other",
  乳酪: "dairy",
  乳酸菌饮料: "other",
  乳鸽: "meat",
  乳鸽蛋: "dairy",
  二荆条: "produce",
  云南辣椒: "produce",
  云吞: "other",
  云盘蘑: "produce",
  云耳: "produce",
  五敛子: "fruit",
  五花肉: "meat",
  五香粉: "other",
  亚侧耳: "produce",
  亚麻籽: "other",
  人参果: "fruit", // pepino melon / ginseng fruit
  人心果: "fruit",
  人造奶油: "other",
  人造黄油: "other",
  仙人掌果: "fruit",
  伊丽莎白瓜: "fruit",
  优格: "dairy",
  低筋面粉: "other",
  低糖酸奶: "dairy",
  低脂奶: "dairy",
  低脂牛奶: "dairy",
  余甘子: "fruit",
  佛手瓜: "produce",
  佛手瓜苗: "produce",
  佳沛奇异果: "fruit",
  侧耳: "produce",
  侧耳根: "produce",
  倭瓜: "produce",
  储良龙眼: "fruit",
  元蘑: "produce",
  元贝: "seafood",
  光盖菇: "produce",
  光黄瓜: "produce",
  克伦生葡萄: "fruit",
  兔子: "meat",
  兔肉: "meat",
  兔腿: "meat",
  全脂奶: "dairy",
  全脂奶粉: "other",
  全脂牛奶: "dairy",
  全脂酸奶: "dairy",
  全麦粉: "other",
  全麦面包: "other",
  八爪鱼: "seafood",
  八角: "other",
  兰花菇: "produce",
  内酯豆腐: "other",
  冬枣: "fruit",
  冬瓜: "produce",
  冬瓜苗: "produce",
  冬笋: "produce",
  冬菇: "produce",
  冬菜: "other",
  冰冻虾仁: "seafood",
  冰李: "fruit",
  冰棍: "other",
  冰淇淋: "other",
  冰激凌: "other",
  冰糖: "other",
  冰糖心苹果: "fruit",
  冰糖橙: "fruit",
  冰菜: "produce",
  冰虾: "seafood",
  冷冻扇贝: "other",
  冷冻毛豆: "other",
  冷冻海鲜: "other",
  冷冻混合蔬菜: "other",
  冷冻牛肉: "other",
  冷冻猪肉: "other",
  冷冻玉米: "other",
  冷冻羊肉: "other",
  冷冻肉类: "other",
  冷冻胡萝卜: "other",
  冷冻花菜: "other",
  冷冻蔬菜: "other",
  冷冻虾仁: "other",
  冷冻西兰花: "other",
  冷冻豌豆: "other",
  冷冻青豆: "other",
  冷冻章鱼: "other",
  冷冻饺子: "other",
  冷冻鱼: "other",
  冷冻鱿鱼: "other",
  冷冻鸡肉: "other",
  冻虾: "seafood",
  冻豆腐: "other",
  凉瓜: "produce",
  凝固型酸奶: "dairy",
  凤尾菇: "produce",
  凤梨: "fruit",
  凯撒酱: "other",
  凯特芒: "fruit",
  刀豆: "produce",
  刁草: "produce",
  分葱: "produce",
  切达奶酪: "dairy",
  初榨橄榄油: "other",
  初生蛋: "dairy",
  刨碎奶酪: "dairy",
  利马豆: "other",
  刺嫩芽: "produce",
  刺梨: "fruit",
  刺老芽: "produce",
  刺黄瓜: "produce",
  刺龙芽: "produce",
  剁椒: "other",
  前腿肉: "meat",
  剪脚香菇: "produce",
  功能饮料: "other",
  加州西梅: "fruit",
  加拿大车厘子: "fruit",
  加拿大龙虾: "seafood",
  包子: "other",
  包心菜: "produce",
  包脚菇: "produce",
  包菜: "produce",
  北京烤鸭: "other",
  北极甜虾: "seafood",
  北极虾: "seafood",
  北极贝: "seafood",
  北豆腐: "other",
  北风菌: "produce",
  十三香: "other",
  千岛酱: "other",
  千禧果: "produce",
  千禧番茄: "produce",
  午餐肉: "other",
  华夫饼: "other",
  单环刺螠: "seafood",
  南华菇: "produce",
  南姜: "produce",
  南瓜: "produce",
  南瓜子: "other",
  南瓜花: "produce",
  南瓜苗: "produce",
  南美白对虾: "seafood",
  南美白虾: "seafood",
  南豆腐: "other",
  卡门贝尔奶酪: "dairy",
  卤牛肉: "other",
  卤猪蹄: "other",
  卤肉: "other",
  卤蛋: "other",
  卤鸡: "other",
  卤鸭: "other",
  即食燕麦: "other",
  卷叶欧芹: "produce",
  卷心菜: "produce",
  厄瓜多尔白虾: "seafood",
  厚菇: "produce",
  原味酸奶: "dairy",
  叉烧: "meat",
  叉烧肉: "other",
  叉烧酱: "other",
  双孢菇: "produce",
  双孢蘑菇: "produce",
  发芽豆: "produce",
  发酵乳: "dairy",
  发酵黄油: "dairy",
  变蛋: "other",
  口水鸡: "other",
  口蘑: "produce",
  口香糖: "other",
  叫花鸡: "other",
  可乐: "other",
  可颂: "other",
  台湾凤梨: "fruit",
  台湾木瓜: "fruit",
  台湾青枣: "fruit",
  叶牡丹: "produce",
  合掌瓜: "produce",
  吉拉多生蚝: "seafood",
  吊菜子: "produce",
  后腿肉: "meat",
  吐司: "other",
  吞拿鱼: "seafood",
  吞拿鱼罐头: "other",
  味精: "other",
  味噌: "other", // miso paste
  味噌酱: "other", // miso paste
  咖啡: "other",
  咖啡粉: "other",
  咖啡豆: "other",
  咖喱: "other",
  咖喱块: "other",
  咖喱粉: "other",
  咖喱膏: "other",
  咸菜: "other",
  咸蛋: "other",
  咸鸭蛋: "other",
  哈密瓜: "fruit",
  哈斯牛油果: "fruit",
  响螺: "seafood",
  啡蘑菇: "produce",
  啤梨: "fruit",
  喷射奶油: "dairy",
  嘎啦苹果: "fruit",
  四季橘: "fruit",
  四季豆: "produce",
  四季豆苗: "produce",
  四川泡菜: "other",
  四川辣椒: "produce",
  四棱豆: "produce",
  国光苹果: "fruit",
  圆椒: "produce",
  圆白菜: "produce",
  圆茄子: "produce",
  土豆: "produce",
  土鸡: "meat",
  土鸡蛋: "dairy",
  圣代: "other",
  圣女果: "produce",
  地瓜: "produce",
  地黄瓜: "produce",
  坚果: "other",
  培根: "meat",
  基围虾: "seafood",
  塘鲺: "seafood",
  夏威夷木瓜: "fruit",
  夏威夷果: "other",
  夏菇: "produce",
  夏黑葡萄: "fruit",
  多宝鱼: "seafood",
  大冬瓜: "produce",
  大台芒: "fruit",
  大叶菠菜: "produce",
  大叶香菜: "produce",
  大料: "other",
  大棚番茄: "produce",
  大棚茄子: "produce",
  大棚黄瓜: "produce",
  大牛心: "produce",
  大球盖菇: "produce",
  大球菌: "produce",
  大番茄: "produce",
  大白菜: "produce",
  大米: "other",
  大红番茄: "produce",
  大芥菜: "produce",
  大苦瓜: "produce",
  大茴香: "other",
  大葱: "produce",
  大葱头: "produce",
  大蒜: "produce",
  大蕉: "fruit",
  大蘑菇: "produce",
  大虾: "seafood",
  大西洋鲑: "seafood",
  大豆: "other",
  大豆油: "other",
  大闸蟹: "seafood",
  大青枣: "fruit",
  大青椒: "produce",
  大黄鱼: "seafood",
  太平洋生蚝: "seafood",
  太平洋鲑: "seafood",
  夹心饼干: "other",
  奇亚籽: "other",
  奇异果: "fruit",
  奶: "dairy",
  奶油: "dairy",
  奶油南瓜: "produce",
  奶油奶酪: "dairy",
  奶油生菜: "produce",
  奶油芝士: "dairy",
  奶油草莓: "fruit",
  奶油蛋糕: "other",
  奶油面包: "other",
  奶白菜: "produce",
  奶粉: "other",
  奶茶: "other",
  奶酪: "dairy",
  奶酪丝: "dairy",
  奶酪块: "dairy",
  奶酪条: "dairy",
  奶酪片: "dairy",
  如意菜: "produce",
  妃子笑: "fruit", // Feizixiao lychee variety (short form)
  妃子笑荔枝: "fruit",
  姑娘果: "fruit",
  姜: "produce",
  姜丝: "produce",
  姜块: "produce",
  姜末: "produce",
  姜片: "produce",
  姜蓉: "produce",
  姜黄: "other",
  威化: "other",
  威化饼: "other",
  娃娃菜: "produce",
  婴儿奶粉: "other",
  嫩南瓜: "produce",
  嫩姜: "produce",
  嫩玉米: "produce",
  嫩瓜: "produce",
  嫩茄子: "produce",
  嫩蚕豆: "produce",
  嫩豆腐: "other",
  嫩豆角: "produce",
  嫩豌豆: "produce",
  嫩黄瓜: "produce",
  子姜: "produce",
  子弹头: "produce",
  孜然: "other",
  孜然粉: "other",
  孜然粒: "other",
  宁波年糕: "other",
  安康鱼: "seafood",
  宝塔花菜: "produce",
  宣木瓜: "fruit",
  宽粉: "other",
  宽豆角: "produce",
  密刺黄瓜: "produce",
  富士苹果: "fruit",
  富平柿子: "fruit",
  对虾: "seafood",
  寿司米: "other",
  小冬瓜: "produce",
  小台芒: "fruit",
  小叶香菜: "produce",
  小土豆: "produce",
  小瓜: "produce",
  小甘蓝: "produce",
  小番茄: "produce",
  小白菜: "produce",
  小笼包: "other",
  小米: "other",
  小米椒: "produce",
  小米辣: "produce",
  小红莓: "fruit",
  小芋头: "produce",
  小芥菜: "produce",
  小苦瓜: "produce",
  小茴香: "produce", // fresh fennel herb
  小菠菜: "produce",
  小葱: "produce",
  小蘑菇: "produce",
  小虾: "seafood",
  小西瓜: "fruit",
  小西红柿: "fruit",
  小豆苗: "produce",
  小章鱼: "seafood",
  小鲍鱼: "seafood",
  小麦芽: "produce",
  小黄瓜: "produce",
  小黄鱼: "seafood",
  小墨鱼: "seafood",
  小龙虾: "seafood",
  尖塔花菜: "produce",
  尖椒: "produce",
  尤力克柠檬: "fruit",
  山椒: "other",
  山楂: "fruit", // hawthorn berry
  山楂酱: "other",
  山竹: "fruit",
  山羊奶酪: "dairy",
  山芋: "produce",
  山药: "produce",
  山药片: "other", // dried yam slices
  山药蛋: "produce",
  山药豆: "produce",
  山葵: "other",
  岩盐: "other",
  岩龙虾: "seafood",
  巧克力: "other",
  巧克力草莓: "fruit",
  巨峰葡萄: "fruit",
  巴氏杀菌奶: "dairy",
  巴沙鱼: "seafood",
  布丁: "other",
  布里奶酪: "dairy",
  希腊酸奶: "dairy",
  帕尔马干酪: "dairy",
  帕玛森芝士: "dairy",
  帝王蟹: "seafood",
  带子: "seafood",
  带花黄瓜: "produce",
  带鱼: "seafood",
  干尧榴莲: "fruit",
  干巴菌: "other",
  干山药: "other", // dried yam
  干木耳: "other",
  干松茸: "other",
  干枣: "other",
  干猴头菇: "other",
  干竹荪: "other",
  干羊肚菌: "other",
  干茶树菇: "other",
  干葱: "produce",
  干豆角: "other",
  干贝: "seafood",
  干辣椒: "other",
  干酪: "dairy",
  干银耳: "other",
  干香菇: "other",
  干黄花菜: "other",
  平叶欧芹: "produce",
  平菇: "produce",
  年糕: "other",
  库尔勒香梨: "fruit",
  开心果: "other",
  彩椒: "produce",
  徐香猕猴桃: "fruit",
  心里美: "produce",
  心里美萝卜: "produce",
  恐龙蛋: "fruit",
  意大利欧芹: "produce",
  意大利西葫芦: "produce",
  意大利面: "other",
  意大利香菜: "produce",
  意大利醋: "other", // balsamic vinegar
  意大利黑醋: "other", // balsamic vinegar
  意粉: "other",
  慈姑: "produce",
  慕斯蛋糕: "other",
  成人奶粉: "other",
  扁桃仁: "other",
  扁豆: "produce",
  扁豆苗: "produce",
  扇贝: "seafood",
  扇贝肉: "seafood",
  手瓜: "produce",
  打发奶油: "dairy",
  托曼尼榴莲: "fruit",
  抄手: "other",
  折耳根: "produce",
  披萨: "other",
  抱子甘蓝: "produce",
  拉面: "other",
  挂面: "other",
  指天椒: "produce",
  挪威三文鱼: "seafood",
  掐菜: "produce",
  排骨酱: "other",
  提子: "fruit",
  提子干: "other",
  提拉米苏: "other",
  搅打奶油: "dairy",
  搅拌型酸奶: "dairy",
  搅瓜: "produce",
  撇蓝: "produce",
  散叶生菜: "produce",
  文旦: "fruit",
  文蛤: "seafood",
  斑节虾: "seafood",
  料酒: "other",
  绍兴酒: "other", // shaoxing wine
  绍兴黄酒: "other", // shaoxing yellow wine
  绍兴料酒: "other", // shaoxing cooking wine
  新土豆: "produce",
  新奇士橙: "fruit",
  新疆哈密瓜: "fruit",
  新疆辣椒: "produce",
  新蒜: "produce",
  新鲜无花果: "fruit",
  新鲜牛奶: "dairy",
  新鲜菠菜: "produce",
  方便面: "other",
  方形西瓜: "fruit",
  方椒: "produce",
  方糖: "other",
  无刺黄瓜: "produce",
  无盐黄油: "dairy",
  无籽西瓜: "fruit",
  无籽黑提: "fruit",
  无糖酸奶: "dairy",
  无花果: "fruit",
  无花果干: "other",
  无菌蛋: "dairy",
  日本南瓜: "produce",
  日本茄子: "produce",
  日本豆腐: "other",
  日本黄瓜: "produce",
  旱黄瓜: "produce",
  时萝: "produce",
  是拉差: "other", // sriracha sauce (transliteration)
  是拉差辣椒酱: "other", // sriracha hot sauce
  昆仑瓜: "produce",
  昆布: "other",
  明太鱼: "seafood",
  明虾: "seafood",
  星果: "fruit",
  春笋: "produce",
  春菇: "produce",
  春菊: "produce",
  春见: "fruit",
  普洱茶: "other",
  智利三文鱼: "seafood",
  智利车厘子: "fruit",
  曲奇: "other",
  曲奇饼: "other",
  月桂叶: "other",
  月饼: "other",
  有机牛奶: "dairy",
  有机番茄: "produce",
  有机花菜: "produce",
  有机茄子: "produce",
  有机草莓: "fruit",
  有机蔬菜: "produce",
  有机西兰花: "produce",
  有机豆芽: "produce",
  有机香菇: "produce",
  有机鸡蛋: "dairy",
  有机黄瓜: "produce",
  有盐黄油: "dairy",
  有籽西瓜: "fruit",
  朝天椒: "produce",
  木瓜: "fruit",
  木耳: "produce",
  木耳菜: "produce",
  木耳菜叶: "produce",
  木薯: "produce",
  杂色蛤: "seafood",
  杂菜: "produce",
  李子: "fruit",
  杏: "fruit",
  杏仁: "other",
  杏仁奶: "other",
  杏子: "fruit",
  杏干: "other",
  杏酱: "other",
  杏鲍菇: "produce",
  杨桃: "fruit",
  杨桃豆: "produce",
  杨梅: "fruit",
  杭椒: "produce",
  松乳菇: "produce",
  松子: "other",
  松花蛋: "other",
  松茸: "produce",
  松露: "produce",
  松饼: "other",
  姬松茸: "produce", // hon-shimeji mushroom
  板栗: "other",
  板栗南瓜: "produce",
  板鸭: "other",
  枇杷: "fruit",
  果冻: "other",
  果桑: "fruit",
  果汁: "other",
  果酱: "other",
  枝豆: "produce",
  枣: "fruit",
  枫糖: "other",
  枫糖浆: "other",
  架豆: "produce",
  架黄瓜: "produce",
  柑: "fruit",
  柑橘: "fruit",
  柚子: "fruit",
  柠檬: "fruit",
  柠檬水: "other",
  柠檬汁: "other",
  柠檬片: "fruit",
  柠檬百香果: "fruit",
  柠檬罗勒: "produce",
  柠檬草: "produce",
  柠檬薄荷: "produce",
  柠檬酱: "other",
  柱候酱: "other",
  柳橙: "fruit",
  柳芽: "produce",
  柴鸡蛋: "dairy",
  柿子: "fruit",
  柿子干: "other",
  柿子椒: "produce",
  柿饼: "other",
  树莓: "fruit",
  栗子: "other",
  核桃: "other",
  核桃仁: "other",
  核桃奶: "other",
  桂叶: "other",
  桂味荔枝: "fruit",
  桂圆: "other",
  桂圆干: "other",
  桂林米粉: "other",
  桂皮: "other",
  桂鱼: "seafood",
  桃: "fruit",
  桃子: "fruit",
  桃酥: "other",
  桃酱: "other",
  桑果: "fruit",
  桑葚: "fruit",
  桔子: "fruit",
  梅: "fruit",
  梅头肉: "meat",
  梅干菜: "other",
  梅花肉: "meat",
  梨: "fruit",
  梨子: "fruit",
  梭子蟹: "seafood",
  棒棒糖: "other",
  棕蘑菇: "produce",
  植物奶油: "other",
  植物油: "other",
  植物黄油: "other",
  椰奶: "other",
  椰子: "fruit",
  椰子油: "other",
  椰枣: "fruit",
  椰汁: "other",
  椰浆: "other",
  椰皇: "fruit",
  椰肉: "fruit",
  椰蓉: "other",
  椰蓉面包: "other",
  椰青: "fruit",
  椴木香菇: "produce",
  椿芽: "produce",
  榆耳: "produce",
  榆钱: "produce",
  榆黄蘑: "produce",
  榛子: "other",
  榨菜: "other",
  榴莲: "fruit",
  榴莲干: "other",
  榴莲肉: "fruit",
  槐花: "produce",
  槟榔芋: "produce",
  樱桃: "fruit",
  樱桃番茄: "produce",
  樱桃萝卜: "produce",
  橄榄油: "other",
  橘子: "fruit",
  橙: "fruit",
  橙圣女果: "produce",
  橙子: "fruit",
  橙椒: "produce",
  橙汁: "other",
  橙片: "fruit",
  橙番茄: "produce",
  橙皮酱: "other",
  欧芹: "produce",
  武昌鱼: "seafood",
  段木香菇: "produce",
  比目鱼: "seafood",
  比萨: "other",
  毛桃: "fruit",
  毛毛虫面包: "other",
  毛瓜: "produce",
  毛笋: "produce",
  毛节瓜: "produce",
  毛芋: "produce",
  毛芋头: "produce",
  毛荔枝: "fruit",
  毛蚶: "seafood",
  毛蟹: "seafood",
  毛豆: "produce",
  毛豆腐: "other",
  水山药: "produce",
  水晶梨: "fruit",
  水晶菜: "produce",
  水晶葡萄: "fruit",
  水果玉米: "produce",
  水果番茄: "fruit",
  水果酸奶: "dairy",
  水果黄瓜: "produce",
  水煮毛豆: "other",
  水煮蛋: "other",
  水瓜: "produce",
  水田芥: "produce",
  水芹: "produce",
  水芹菜: "produce",
  水萝卜: "produce",
  水蜜桃: "fruit",
  水蜜桃罐头: "other",
  水饺: "other",
  水鱼: "seafood",
  水黄瓜: "produce",
  汉堡: "other",
  汉堡包: "other",
  江米: "other",
  汽水: "other",
  沃柑: "fruit",
  沙丁鱼: "seafood",
  沙姜: "produce",
  沙拉酱: "other",
  沙棘: "fruit",
  沙瓤番茄: "produce",
  沙田柚: "fruit",
  沙茶酱: "other",
  河粉: "other",
  河虾: "seafood",
  河蚌: "seafood",
  河蟹: "seafood",
  河豚: "seafood",
  河鳗: "seafood",
  油: "other",
  油桃: "fruit",
  油甘: "fruit",
  油茶菇: "produce",
  油菜: "produce",
  油豆腐: "other",
  油豆角: "produce",
  油醋汁: "other",
  油麦: "produce",
  油麦菜: "produce",
  法国生蚝: "seafood",
  法棍: "other",
  泡发木耳: "produce",
  泡发银耳: "produce",
  泡椒: "other",
  泡泡糖: "other",
  泡芙: "other",
  泡菜: "other",
  泡面: "other",
  波士顿龙虾: "seafood",
  波特菇: "produce",
  波龙: "seafood",
  泥蚶: "seafood",
  泥鳅: "seafood",
  泰国罗勒: "produce",
  泰椒: "produce",
  洁净蛋: "dairy",
  洋姜: "produce",
  洋柿子: "produce",
  洋瓜: "produce",
  洋白菜: "produce",
  洋芋: "produce",
  洋葱: "produce",
  洋葱丁: "produce",
  洋葱丝: "produce",
  洋葱圈: "produce",
  洋葱块: "produce",
  洋葱头: "produce",
  洋蒲桃: "fruit",
  洋蘑菇: "produce",
  活虾: "seafood",
  浓奶油: "dairy",
  海参: "seafood",
  海带丝: "produce",
  海带片: "produce",
  海带结: "produce",
  海星: "seafood",
  海沃德猕猴桃: "fruit",
  海瓜子: "seafood",
  海白菜: "produce",
  海盐: "other",
  海肠: "seafood",
  海肠子: "seafood",
  海胆: "seafood",
  海胆黄: "seafood",
  海苔: "other",
  海葵: "seafood",
  海虹: "seafood",
  海虾: "seafood",
  海蛎: "seafood", // oyster (regional variant)
  海蛎子: "seafood",
  海蜇: "seafood",
  海蜇头: "seafood",
  海蜇皮: "seafood",
  海螺: "seafood",
  海螺肉: "seafood",
  海蟹: "seafood",
  海鲈鱼: "seafood",
  海鲜菇: "produce",
  海鲜酱: "other",
  海鲷: "seafood",
  海鳗: "seafood",
  涂抹奶酪: "dairy",
  消化饼: "other",
  涩柿: "fruit",
  淡奶油: "dairy",
  淡水虾: "seafood",
  淡水鲈鱼: "seafood",
  淡水龙虾: "seafood",
  淡炼乳: "dairy",
  淡菜: "seafood",
  淮山: "produce",
  混合坚果: "other",
  混合蔬菜: "produce",
  清汤火锅底料: "other",
  温室番茄: "produce",
  温室茄子: "produce",
  温室黄瓜: "produce",
  温泉蛋: "other",
  湖南辣椒: "produce",
  溏心蛋: "other",
  滑子菇: "produce",
  滑菇: "produce",
  澳洲青苹: "fruit",
  澳洲龙虾: "seafood",
  澳芒: "fruit",
  澳龙: "seafood",
  濑尿虾: "seafood",
  灌汤包: "other",
  火晶柿子: "fruit",
  火箭菜: "produce",
  火腿: "meat",
  火腿肠: "other",
  火葱: "produce",
  火锅底料: "other",
  火鸡: "meat",
  火鸡肉: "meat",
  火鸡胸: "meat",
  火龙果: "fruit",
  灯笼果: "fruit",
  灯笼椒: "produce",
  灯笼茄: "produce",
  灰菜: "produce",
  炸鸡: "other",
  炸鸡翅: "other",
  炸鸡腿: "other",
  炼乳: "dairy",
  烟台苹果: "fruit",
  烤肠: "other",
  烤鸡: "other",
  烤鸭: "other",
  烧卖: "other",
  烧鸡: "other",
  烧鹅: "other",
  烧麦: "other",
  热狗: "other",
  热狗面包: "other",
  煎饺: "other",
  蒸饺: "other",
  熟花生: "other",
  燕麦: "other",
  燕麦奶: "other",
  燕麦片: "other",
  爆米花: "other",
  爱媛: "fruit",
  爱媛38号: "fruit",
  牛: "meat",
  牛上脑: "meat",
  牛仔骨: "meat",
  牛前腱: "meat",
  牛后腱: "meat",
  牛外脊: "meat",
  牛奶: "dairy",
  牛奶草莓: "fruit",
  牛小排: "meat",
  牛尾: "meat",
  牛心: "meat",
  牛心番茄: "produce",
  牛排: "meat",
  牛排番茄: "produce",
  牛柳: "meat",
  牛毛肚: "meat",
  牛油: "dairy",
  牛油果: "fruit",
  牛油果油: "other",
  牛油果酱: "other",
  牛番茄: "produce",
  牛百叶: "meat",
  牛筋: "meat",
  牛肉: "meat",
  牛肉丝: "meat",
  牛肉块: "meat",
  牛肉洋葱馅: "meat",
  牛肉片: "meat",
  牛肉番茄: "produce",
  牛肉粒: "meat",
  牛肉馅: "meat",
  牛肋条: "meat",
  牛肚: "meat",
  牛肝: "meat",
  牛肝菌: "produce",
  牛肩肉: "meat",
  牛肺: "meat",
  牛肾: "meat",
  牛胸肉: "meat",
  牛脑: "meat",
  牛腩: "meat",
  牛腩块: "meat",
  牛腰子: "meat",
  牛腰肉: "meat",
  牛腱: "meat",
  牛腱子: "meat",
  牛腱肉: "meat",
  牛至: "produce",
  牛舌: "meat",
  牛蒡: "produce",
  牛蒡根: "produce",
  牛蛙: "meat",
  牛血: "meat",
  牛角包: "other",
  牛角椒: "produce",
  牛蹄: "meat",
  牛蹄筋: "meat",
  牛里脊: "meat",
  牛霖: "meat",
  牛鞭: "meat",
  牛颈肉: "meat",
  牛骨: "meat",
  牡丹虾: "seafood",
  牡蛎: "seafood",
  独头蒜: "produce",
  独蒜: "produce",
  狭鳕鱼: "seafood",
  猕猴桃: "fruit",
  猪: "meat",
  猪前腿: "meat",
  猪前腿肉: "meat",
  猪后腿: "meat",
  猪后腿肉: "meat",
  猪外脊: "meat",
  猪大排: "meat",
  猪大肠: "meat",
  猪头肉: "meat",
  猪小排: "meat",
  猪小肠: "meat",
  猪尾: "meat", // pig tail
  猪尾巴: "meat",
  猪心: "meat",
  猪手: "meat",
  猪排: "meat",
  猪油: "other",
  猪牛肉馅: "meat",
  猪皮: "meat",
  猪耳: "meat", // pig ear
  猪耳朵: "meat",
  猪肉: "meat",
  猪肉丁: "meat",
  猪肉丝: "meat",
  猪肉片: "meat",
  猪肉粒: "meat",
  猪肉饺子: "other",
  猪肉馅: "meat",
  猪肋排: "meat",
  猪肘: "meat",
  猪肚: "meat",
  猪肝: "meat",
  猪肠: "meat",
  猪肺: "meat",
  猪脑: "meat",
  猪脚: "meat",
  猪腰: "meat",
  猪腰子: "meat",
  猪舌: "meat",
  猪血: "meat",
  猪蹄: "meat",
  猪蹄膀: "meat",
  猪通脊: "meat",
  猪里脊: "meat",
  猪颈肉: "meat",
  猪骨: "meat",
  猪鼻孔: "produce",
  排骨: "meat", // ribs (pork or beef)
  猫山王: "fruit", // Musang King durian variety (short form)
  猫山王榴莲: "fruit",
  猴头菇: "produce",
  玉米: "produce",
  玉米棒: "produce",
  玉米段: "produce",
  玉米油: "other",
  玉米笋: "produce",
  玉米粉: "other",
  玉米粒: "produce",
  玉米粒罐头: "other",
  玉米面: "other",
  玉米须: "produce",
  玉蔓菁: "produce",
  玉蕈: "produce",
  王八: "seafood",
  玫瑰香葡萄: "fruit",
  玻璃生菜: "produce",
  珍宝蟹: "seafood",
  珍珠奶茶: "other",
  珍珠洋葱: "produce",
  珍珠番茄: "fruit",
  珍珠米: "other",
  珍珠菇: "produce",
  球生菜: "produce",
  球芽甘蓝: "produce",
  球茎甘蓝: "produce",
  琯溪蜜柚: "fruit",
  琵琶腿: "meat",
  琵琶虾: "seafood",
  瑞士卷: "other",
  瑞士奶酪: "dairy",
  瓜子: "other",
  瓠子: "produce",
  瓠瓜: "produce",
  甘蓝: "produce",
  甘薯: "produce",
  甜查理草莓: "fruit",
  甜柿: "fruit",
  甜椒: "produce",
  甜椒苗: "produce",
  甜洋葱: "produce",
  甜炼乳: "dairy",
  甜玉米: "produce",
  甜瓜: "fruit",
  甜筒: "other",
  甜罗勒: "produce",
  甜菜: "produce",
  甜菜根: "produce",
  甜虾: "seafood",
  甜豆: "produce",
  甜豆角: "produce",
  甜面酱: "other",
  生姜: "produce",
  生抽: "other",
  生日蛋糕: "other",
  生煎包: "other",
  生花生: "other",
  生菜: "produce",
  生蚝: "seafood",
  生鱼: "seafood",
  田螺: "seafood",
  田鸡: "meat",
  甲仑榴莲: "fruit",
  甲鱼: "seafood",
  留兰香: "produce",
  番木瓜: "fruit",
  番瓜: "produce",
  番石榴: "fruit",
  番茄: "produce",
  番茄沙司: "other",
  番茄秧: "produce",
  番茄苗: "produce",
  番茄酱: "other",
  番荔枝: "fruit",
  番薯: "produce",
  癞瓜: "produce",
  白兰瓜: "fruit",
  白冬瓜: "produce",
  白加仑: "fruit",
  白壳鸡蛋: "dairy",
  白干: "other",
  白心柚: "fruit",
  白心火龙果: "fruit",
  白心萝卜: "produce",
  白斩鸡: "other",
  白木耳: "produce",
  白条鱼: "seafood",
  白杨梅: "fruit",
  白松露: "produce",
  白枇杷: "fruit",
  白桃: "fruit",
  白桑葚: "fruit",
  白椒: "produce",
  白洋葱: "produce",
  白灵菇: "produce",
  白玉米: "produce",
  白玉菇: "produce",
  白瓜子: "other",
  白甘蓝: "produce",
  白番茄: "produce",
  白皮茄: "produce",
  白皮蒜: "produce",
  白石榴: "fruit",
  白米: "other",
  白糖: "other",
  白糖罂荔枝: "fruit",
  白肉桃: "fruit",
  白胡椒: "other",
  白腰豆: "other",
  白芝麻: "other",
  白芦笋: "produce",
  白花菜: "produce",
  白芷: "other",
  白芸豆: "other",
  白苏: "produce",
  白苦瓜: "produce",
  白茄子: "produce",
  白草莓: "fruit",
  白菜: "produce",
  白菜猪肉馅: "meat",
  白萝卜: "produce",
  白薯: "produce",
  白蘑: "produce",
  白蘑菇: "produce",
  白虾: "seafood",
  白蛤: "seafood",
  白西柚: "fruit",
  白豆蔻: "other",
  白豆角: "produce",
  白醋: "other",
  白金针菇: "produce",
  白面包: "other",
  白饭鱼: "seafood",
  白鲢: "seafood",
  白鲳: "seafood",
  白鳝: "seafood",
  白黄瓜: "produce",
  百里香: "produce",
  百香果: "fruit",
  皇冠梨: "fruit",
  皇帝蕉: "fruit",
  皮皮虾: "seafood",
  皮蛋: "other",
  皱叶甘蓝: "produce",
  益生菌酸奶: "dairy",
  盐: "other",
  盐水毛豆: "other",
  盐水鸭: "other",
  盐菜: "other",
  目鱼: "seafood",
  眉豆: "other",
  真姬菇: "produce",
  真鳕鱼: "seafood",
  眼肉牛排: "meat",
  短圆茄: "produce",
  短豆芽: "produce",
  短豆角: "produce",
  短黄瓜: "produce",
  矮瓜: "produce",
  矮茄子: "produce",
  矮豆: "produce",
  石斑鱼: "seafood",
  石榴: "fruit",
  石榴汁: "other",
  石榴籽: "fruit",
  石硖龙眼: "fruit",
  石花菜: "produce",
  石蟹: "seafood",
  砀山梨: "fruit",
  砂仁: "other",
  砂糖: "other",
  砂糖橘: "fruit",
  硬果番茄: "produce",
  硬桃: "fruit",
  硬番茄: "produce",
  硬糖: "other",
  硬质奶酪: "dairy",
  碎奶酪: "dairy",
  碎肉: "meat",
  碧根果: "other",
  碳酸饮料: "other",
  磅蛋糕: "other",
  神秘果: "fruit",
  神菇: "produce",
  福寿螺: "seafood",
  秀珍菇: "produce",
  秋刀鱼: "seafood",
  秋月梨: "fruit",
  秋菇: "produce",
  秋葵: "produce",
  秦冠苹果: "fruit",
  秦椒: "produce",
  秧黄瓜: "produce",
  稀刺黄瓜: "produce",
  稀奶油: "dairy",
  稍瓜: "produce",
  稻草菇: "produce",
  空心菜: "produce",
  空心菜芽: "produce",
  突尼斯软籽石榴: "fruit",
  童子鸡: "meat",
  竹笋: "produce",
  竹节虾: "seafood",
  竹荪: "produce",
  竹蛏: "seafood",
  笋尖: "produce",
  笋干: "other",
  笋片: "produce",
  笋瓜: "produce",
  笋衣: "produce",
  笨鸡蛋: "dairy",
  筒骨: "meat",
  米浆: "other",
  米粉: "other",
  米线: "other",
  米蕉: "fruit",
  米酒: "other",
  米醋: "other",
  籼米: "other",
  粉丝: "other",
  粉壳鸡蛋: "dairy",
  粉条: "other",
  粉果番茄: "produce",
  粉番茄: "produce",
  粉蕉: "fruit",
  粗茄子: "produce",
  粗豆芽: "produce",
  粘糕: "other",
  粳米: "other",
  糖: "other",
  糖果: "other",
  糖浆: "other",
  糖炒栗子: "other",
  糖粉: "other",
  糙米: "other",
  糯玉米: "produce",
  糯米: "other",
  糯米椒: "produce",
  糯米糍: "fruit", // Nuomici lychee variety (short form)
  糯米糍荔枝: "fruit",
  素火腿: "other",
  素肉: "other",
  素面: "other",
  素鸡: "other",
  素鸭: "other",
  紫叶甘蓝: "produce",
  紫叶生菜: "produce",
  紫圆茄: "produce",
  紫土豆: "produce",
  紫圣女果: "produce",
  紫地瓜: "produce",
  紫山药: "produce",
  紫心红薯: "produce",
  紫心薯: "produce",
  紫椒: "produce",
  紫洋葱: "produce",
  紫玉米: "produce",
  紫甘蓝: "produce",
  紫番茄: "produce",
  紫皮蒜: "produce",
  紫米: "other",
  紫罗勒: "produce",
  紫背天葵: "produce",
  紫芦笋: "produce",
  紫花菜: "produce",
  紫苏: "produce",
  紫苏叶: "produce",
  紫苤蓝: "produce",
  紫茄子: "produce",
  紫菜: "other",
  紫菜苔: "produce",
  紫薯: "produce",
  紫豆角: "produce",
  紫长茄: "produce",
  红凤菜: "produce",
  红加仑: "fruit",
  红包菜: "produce",
  红叶生菜: "produce",
  红咖喱: "other",
  红土豆: "produce",
  红圣女果: "produce",
  红地球葡萄: "fruit",
  红壳鸡蛋: "dairy",
  红富士苹果: "fruit",
  红将军苹果: "fruit",
  红布林: "fruit",
  红心柚: "fruit",
  红心火龙果: "fruit",
  红心猕猴桃: "fruit",
  红心萝卜: "produce",
  红心薯: "produce",
  红提: "fruit",
  红木瓜: "fruit",
  红李: "fruit",
  红富士: "fruit", // Fuji apple variety
  红杏: "fruit",
  红杨梅: "fruit",
  红枣: "other",
  红柿子: "produce",
  红树莓: "fruit",
  红梨: "fruit",
  红椒: "produce",
  红樱桃: "fruit",
  红橘: "fruit",
  红橙: "fruit",
  红毛丹: "fruit",
  红洋葱: "produce",
  红灯樱桃: "fruit",
  红烧肉: "other",
  红玛瑙: "fruit",
  红瓤西瓜: "fruit",
  红甘蓝: "produce",
  红皮萝卜: "produce",
  红皮香蕉: "fruit",
  红石斑: "seafood",
  红石榴: "fruit",
  红秋葵: "produce",
  红米: "other",
  红糖: "other",
  红腰豆: "other",
  红花椒: "other",
  红芸豆: "other",
  红苋菜: "produce",
  红茄子: "produce",
  红茶: "other",
  红菇: "produce",
  红菜头: "produce",
  红菜苔: "produce",
  红菱: "produce",
  红萝卜: "produce",
  红葱头: "produce",
  红酒: "other", // red wine (cooking)
  红酒醋: "other", // red wine vinegar
  红薯: "produce",
  红薯粉: "other",
  红虾: "seafood",
  红蛇果: "fruit",
  红蟹: "seafood",
  红西柚: "fruit",
  红豆: "other",
  红豆芽: "produce",
  红豆角: "produce",
  红象牙芒: "fruit",
  红辣椒: "produce",
  红颜草莓: "fruit",
  红香椿: "produce",
  红鲷鱼: "seafood",
  纯牛奶: "dairy",
  纸杯蛋糕: "other",
  线椒: "produce",
  线茄: "produce",
  细茄子: "produce",
  细豆芽: "produce",
  细豆角: "produce",
  舒化奶: "dairy", // Shuhua milk brand (lactose-free)
  高钙奶: "dairy", // high-calcium milk
  细香葱: "produce",
  结球甘蓝: "produce",
  绞肉: "meat",
  绵白糖: "other",
  绿叶甘蓝: "produce",
  绿叶生菜: "produce",
  绿咖喱: "other",
  绿哈密瓜: "fruit",
  绿圣女果: "produce",
  绿心猕猴桃: "fruit",
  绿提: "fruit",
  绿甘蓝: "produce",
  绿番茄: "produce",
  绿秋葵: "produce",
  绿芦笋: "produce",
  绿花菜: "produce",
  绿苋菜: "produce",
  绿茄子: "produce",
  绿茶: "other",
  绿薄荷: "produce",
  绿豆: "other",
  绿豆芽: "produce",
  绿豆苗: "produce",
  绿香椿: "produce",
  绿黄瓜: "produce",
  缢蛏: "seafood",
  罐头: "other",
  罐头凤尾鱼: "other",
  罐头午餐肉: "other",
  罐头梨: "other",
  罐头橘子: "other",
  罐头沙丁鱼: "other",
  罐头火腿: "other",
  罐头牛肉: "other",
  罐头猪肉: "other",
  罐头玉米: "other",
  罐头荔枝: "other",
  罐头蘑菇: "other",
  罐头豌豆: "other",
  罐头金枪鱼: "other",
  罐头鸡肉: "other",
  罐头黄桃: "other",
  罐装玉米: "other",
  网纹瓜: "fruit",
  罗勒: "produce",
  罗氏虾: "seafood",
  罗汉豆: "produce",
  罗非鱼: "seafood",
  罗马生菜: "produce",
  罗马花菜: "produce",
  羊: "meat",
  羊头肉: "meat",
  羊尾: "meat",
  羊心: "meat",
  羊排: "meat",
  羊柳: "meat",
  羊栖菜: "produce",
  羊棒骨: "meat",
  羊肉: "meat",
  羊肉串: "meat",
  羊肉冬瓜馅: "meat",
  羊肉卷: "meat",
  羊肉大葱馅: "meat",
  羊肉片: "meat",
  羊肉胡萝卜馅: "meat",
  羊肉馅: "meat",
  羊肋排: "meat",
  羊肚: "meat",
  羊肚菌: "produce",
  羊肝: "meat",
  羊肠: "meat",
  羊肩肉: "meat",
  羊肺: "meat",
  羊肾: "meat",
  羊脑: "meat",
  羊脸肉: "meat",
  羊腩: "meat",
  羊腰: "meat", // lamb/mutton kidney
  羊腰子: "meat",
  羊腰肉: "meat",
  羊腿: "meat",
  羊腿肉: "meat",
  羊舌: "meat",
  羊蝎子: "meat",
  羊血: "meat",
  羊角椒: "produce",
  羊角瓜: "fruit",
  羊角蜜: "fruit",
  羊角豆: "produce",
  羊角面包: "other",
  羊蹄: "meat",
  羊里脊: "meat",
  羊颈肉: "meat",
  羊骨: "meat",
  美乃滋: "other",
  美人瓜: "produce",
  美味草菇: "produce",
  美国大杏仁: "other",
  美早樱桃: "fruit",
  美洲南瓜: "produce",
  美芹: "produce",
  羽衣甘蓝: "produce",
  翠冠梨: "fruit",
  翼豆: "produce",
  老南瓜: "produce",
  老姜: "produce",
  老抽: "other",
  老椰子: "fruit",
  老玉米: "produce",
  老茄子: "produce",
  老蒜: "produce",
  老虎斑: "seafood",
  老豆腐: "other",
  老豆角: "produce",
  老酸奶: "dairy",
  老黄瓜: "produce",
  耙耙柑: "fruit",
  肉包子: "other",
  肉末: "meat",
  肉松面包: "other",
  肉桂: "other",
  肉沫: "meat",
  肉眼牛排: "meat",
  肉糜: "meat",
  肉蟹: "seafood",
  肉豆蔻: "other",
  肉馅: "meat",
  肠粉: "other",
  肥羊: "meat",
  胖头鱼: "seafood",
  胡椒: "other",
  胡椒粉: "other",
  胡椒粒: "other",
  胡椒薄荷: "produce",
  胡荽: "produce",
  胡萝卜: "produce",
  胡萝卜丁: "produce",
  胡萝卜条: "produce",
  胡萝卜片: "produce",
  胡葱: "produce",
  胡豆: "produce",
  能量饮料: "other",
  脆柿: "fruit",
  脐橙: "fruit",
  脱脂奶: "dairy",
  脱脂奶粉: "other",
  脱脂牛奶: "dairy",
  脱脂酸奶: "dairy",
  腊肉: "other", // cured pork - base form is processed food (100克腊肉 → meat when sold by weight)
  腊肠: "other",
  腌菜: "other",
  腌萝卜: "other",
  腌黄瓜: "other",
  腐乳: "other",
  腐竹: "other",
  腰果: "other",
  腰果奶: "other",
  腰豆: "other",
  膏蟹: "seafood",
  臭椿: "produce",
  臭菜根: "produce",
  臭豆腐: "other",
  舌鳎鱼: "seafood",
  良姜: "other",
  艾叶: "produce",
  艾蒿: "produce",
  艾门塔尔奶酪: "dairy",
  节瓜: "produce",
  芋头: "produce",
  芋梗: "produce",
  芋艿: "produce",
  芒果: "fruit",
  芒果干: "other",
  芝士: "dairy",
  芝士蛋糕: "other",
  芝麻: "other",
  芝麻油: "other",
  芝麻菜: "produce",
  芝麻菜叶: "produce",
  芝麻酱: "other",
  芡实: "other", // dried fox nut (dried goods)
  芥兰头: "produce",
  芥兰花: "produce",
  芥兰菜: "produce",
  芥末: "other",
  芥末油: "other",
  芥末酱: "other",
  芥菜: "produce",
  芥蓝: "produce",
  芥蓝苔: "produce",
  芦笋: "produce",
  芦笋尖: "produce",
  芦荟: "produce",
  芦蒿: "produce",
  芦蒿杆: "produce",
  芦虾: "seafood",
  芫荽: "produce",
  芫荽籽: "other", // coriander seeds (spice)
  芬达: "other",
  芭乐: "fruit",
  芭蕉: "fruit",
  花卷: "other",
  花枝: "seafood",
  花椒: "other",
  花椒油: "other",
  花椒粉: "other",
  花椒芽: "produce",
  花椰菜: "produce",
  花牛苹果: "fruit",
  花玉米: "produce",
  花生: "other",
  花生仁: "other",
  花生奶: "other",
  花生油: "other",
  花生米: "other",
  花生芽: "produce",
  花生酱: "other",
  花甲: "seafood",
  花甲肉: "seafood",
  花苔: "produce",
  花茄子: "produce",
  花茶: "other",
  花菇: "produce",
  花菇干: "other",
  花菜: "produce",
  花菜叶: "produce",
  花菜芯: "produce",
  花蛤: "seafood",
  花螺: "seafood",
  花豆: "other",
  花豆角: "produce",
  花鲢: "seafood",
  花黄瓜: "produce",
  芸豆: "produce",
  芹菜: "produce",
  芹菜叶: "produce",
  芹菜心: "produce",
  芹菜根: "produce",
  芹菜猪肉馅: "meat",
  芽球甘蓝: "produce",
  芽苗菜: "produce",
  苋菜: "produce",
  苏打饼干: "other",
  苜蓿: "produce",
  苜蓿芽: "produce",
  苜蓿菜: "produce",
  苣荬菜: "produce",
  苤蓝: "produce",
  苦瓜: "produce",
  苦瓜苗: "produce",
  苦苣: "produce",
  苦菊: "produce",
  苦菜: "produce",
  苹果: "fruit",
  苹果汁: "other",
  苹果薄荷: "produce",
  苹果酱: "other",
  苹果醋: "other",
  茄子: "produce",
  茄子秧: "produce",
  茄子苗: "produce",
  茄果: "produce",
  茄瓜: "produce",
  茉莉花茶: "other",
  茨菰: "produce",
  茭瓜: "produce",
  茭白: "produce",
  茴香: "produce",
  茴香猪肉馅: "meat",
  茴香苗: "produce",
  茴香菜: "produce",
  茶: "other",
  茶叶蛋: "other",
  茶树菇: "produce",
  茶菇: "produce",
  茶薪菇: "produce",
  茼蒿: "produce",
  荆芥: "produce",
  草果: "other",
  草莓: "fruit",
  草莓酱: "other",
  草莓酸奶: "dairy",
  草菇: "produce",
  草虾: "seafood",
  草豆蔻: "other",
  草鱼: "seafood",
  草鸡: "meat",
  草鸡蛋: "dairy",
  荔枝: "fruit",
  荔枝干: "other",
  荔浦芋: "produce",
  荞麦: "other",
  荞麦芽: "produce",
  荞麦面: "other",
  荠菜: "produce",
  药芹: "produce",
  荷兰瓜: "produce",
  荷兰薯: "produce",
  荷兰豆: "produce",
  荷兰豆苗: "produce",
  荷兰豆角: "produce",
  荷兰黄瓜: "produce",
  荷叶: "produce",
  荸荠: "produce",
  莜麦菜: "produce",
  莲子: "other",
  莲花白: "produce",
  莲蓬: "produce",
  莲藕: "produce",
  莲藕节: "produce",
  莲雾: "fruit",
  莳萝: "produce",
  莴笋: "produce",
  莴笋叶: "produce",
  莴苣: "produce",
  莽吉柿: "fruit",
  菊芋: "produce",
  菊苣: "produce",
  菜包子: "other",
  菜山药: "produce",
  菜心: "produce",
  菜椒: "produce",
  菜瓜: "produce",
  菜籽油: "other",
  菜花: "produce",
  菜苔: "produce",
  菜豆苗: "produce",
  菠菜: "produce",
  菠萝: "fruit",
  菠萝包: "other",
  菠萝片: "fruit",
  菠萝罐头: "other",
  菠萝蜜: "fruit",
  菱角: "produce",
  菲力牛排: "meat",
  菲达奶酪: "dairy",
  萝卜: "produce",
  萝卜干: "other",
  萝卜芽: "produce",
  萝卜苗: "produce",
  落苏: "produce",
  落葵: "produce",
  葡式蛋挞: "other",
  葡萄: "fruit",
  葡萄干: "other",
  葡萄柚: "fruit",
  葡萄汁: "other",
  葫芦: "produce",
  葫芦瓜: "produce",
  葱: "produce",
  葱丝: "produce",
  葱叶: "produce",
  葱末: "produce",
  葱段: "produce",
  葱白: "produce",
  葱绿: "produce",
  葱花: "produce",
  葵花籽: "other",
  葵花籽油: "other",
  葵花苗: "produce",
  蒙古口蘑: "produce",
  蒙自石榴: "fruit",
  蒜: "produce",
  蒜头: "produce",
  蒜末: "produce",
  蒜泥: "produce",
  蒜片: "produce",
  蒜瓣: "produce",
  蒜米: "produce",
  蒜苔: "produce",
  蒜苗: "produce",
  蒜蓉: "produce",
  蒜薹: "produce",
  蒜黄: "produce",
  蒲公英: "produce",
  蒿子秆: "produce",
  蓝纹奶酪: "dairy",
  蓝莓: "fruit",
  蓝莓干: "other",
  蓝莓李: "fruit",
  蓝莓酱: "other",
  蓝莓酸奶: "dairy",
  蓝靛果: "fruit",
  蓝鳍金枪鱼: "seafood",
  蓬蒿: "produce",
  蔓越莓: "fruit",
  蔓越莓干: "other",
  蔬菜沙拉: "other",
  蕨菜: "produce",
  蕹菜: "produce",
  蕺菜: "produce",
  薄脆: "other",
  薄荷: "produce",
  薄荷叶: "produce",
  薄荷糖: "other",
  薄菇: "produce",
  薇菜: "produce",
  薏仁: "other",
  薏米: "other",
  薯条: "other",
  薯片: "other",
  薹菜: "produce",
  藕: "produce",
  藕尖: "produce",
  藕带: "produce",
  藕节: "produce",
  藜麦: "other",
  藤椒: "other",
  藤椒油: "other",
  藤菜: "produce",
  蘑菇: "produce",
  蘑菇仔: "produce",
  虎皮椒: "produce",
  虎虾: "seafood",
  虹鳟鱼: "seafood",
  虾: "seafood",
  虾仁: "seafood",
  虾仁饺子: "other",
  虾干: "seafood",
  虾爬子: "seafood", // mantis shrimp
  虾滑: "seafood",
  虾片: "other",
  虾球: "other",
  虾皮: "seafood",
  虾米: "seafood",
  虾膏: "other",
  虾蛄: "seafood",
  虾酱: "other",
  虾饺: "other",
  蚌: "seafood",
  蚌肉: "seafood",
  蚕豆: "produce",
  蚕豆瓣: "produce",
  蚕豆苗: "produce",
  蚝: "seafood",
  蚝油: "other",
  蚝肉: "seafood",
  蚝菇: "produce",
  蚬子: "seafood",
  蛇果: "fruit",
  蛇瓜: "produce",
  蛇肉: "meat",
  蛇豆: "produce",
  蛇豆角: "produce",
  蛋: "dairy",
  蛋卷: "other",
  蛋挞: "other",
  蛋白: "dairy",
  蛋糕: "other",
  蛋黄: "dairy",
  蛋黄果: "fruit",
  蛋黄酱: "other",
  蛎黄: "seafood",
  蛏子: "seafood",
  蛤蜊: "seafood",
  蛤蜊肉: "seafood",
  蜂蜜: "other",
  蜂蜜芥末: "other",
  蜜枣: "other",
  蜜柑: "fruit",
  蜜柚: "fruit",
  蜜橘: "fruit",
  蜜瓜南瓜: "produce",
  蜜菠萝: "fruit",
  螃蟹: "seafood",
  螺丝椒: "produce",
  螺旋花菜: "produce",
  螺蛳: "seafood",
  蟠桃: "fruit",
  蟹: "seafood",
  蟹味菇: "produce",
  蟹柳: "other",
  蟹棒: "other",
  蟹肉: "seafood",
  蟹腿: "seafood",
  蟹酱: "other",
  蟹钳: "seafood",
  蟹黄: "seafood",
  血橙: "fruit",
  血皮菜: "produce",
  血蚶: "seafood",
  袋料香菇: "produce",
  裙带菜: "produce",
  褐蘑菇: "produce",
  西兰花: "produce",
  西兰花苗: "produce",
  西冷牛排: "meat",
  西柚: "fruit",
  西梅: "fruit",
  西洋南瓜: "produce",
  西洋菜: "produce",
  西瓜: "fruit",
  西瓜子: "other",
  西瓜汁: "other",
  西番莲: "fruit",
  西红柿: "produce",
  西红柿苗: "produce",
  西芹: "produce",
  西葫芦: "produce",
  西葫芦瓜: "produce",
  西葫芦苗: "produce",
  西蓝花: "produce",
  覆盆子: "fruit",
  覆盆子酱: "other",
  角瓜: "produce",
  话梅: "other",
  谷物蛋: "dairy",
  豆制品: "other",
  豆奶: "other",
  豆子: "other",
  豆沙包: "other",
  豆泡: "other",
  豆浆: "other",
  豆王: "produce",
  豆瓣菜: "produce",
  豆瓣酱: "other",
  豆腐: "other",
  豆腐乳: "other",
  豆腐干: "other",
  豆腐皮: "other",
  豆腐脑: "other",
  豆花: "other",
  豆芽: "produce",
  豆芽苗: "produce",
  豆芽菜: "produce",
  豆苗: "produce",
  豆苗菜: "produce",
  豆蔻: "other",
  豆角: "produce",
  豆角尖: "produce",
  豆角苗: "produce",
  豆豉: "other",
  豇豆: "produce",
  豇豆干: "other",
  豇豆苗: "produce",
  豌豆: "produce",
  豌豆尖: "produce",
  豌豆芽: "produce",
  豌豆苔: "produce",
  豌豆苗: "produce",
  豌豆苗芽: "produce",
  豌豆荚: "produce",
  象拔蚌: "seafood",
  象牙芒: "fruit",
  象牙蚌: "seafood",
  贝果: "other",
  贝贝南瓜: "produce",
  贡桔: "fruit",
  贡菇: "produce",
  贵妃芒: "fruit",
  贵州辣椒: "produce",
  贻贝: "seafood",
  赣南脐橙: "fruit",
  赤苏: "produce",
  赤豆: "other",
  赤贝: "seafood",
  起司: "dairy",
  超高温灭菌奶: "dairy",
  越橘: "fruit",
  越瓜: "produce",
  车前草: "produce",
  车厘子: "fruit",
  车达奶酪: "dairy",
  软果番茄: "produce",
  软枣猕猴桃: "fruit",
  软柿: "fruit",
  软桃: "fruit",
  软籽石榴: "fruit",
  软糖: "other",
  软质奶酪: "dairy",
  辣木叶: "produce",
  辣根: "other",
  辣椒: "produce",
  辣椒丝: "produce",
  辣椒圈: "produce",
  辣椒段: "produce",
  辣椒油: "other",
  辣椒碎: "produce",
  辣椒秧: "produce",
  辣椒粉: "other",
  辣椒苗: "produce",
  辣椒酱: "other",
  辣椒面: "other",
  辣火锅底料: "other",
  辣白菜: "other",
  运动饮料: "other",
  进口牛油果: "fruit",
  迷你猕猴桃: "fruit",
  迷你番茄: "fruit",
  迷你黄瓜: "produce",
  迷迭香: "produce",
  通心粉: "other",
  通菜: "produce",
  速冻饺子: "other",
  速溶咖啡: "other",
  速食面: "other",
  郫县豆瓣: "other",
  酪蛋白: "other",
  酱油: "other",
  酱牛肉: "other",
  酱肉: "other",
  酱鸭: "other",
  酸乳: "dairy",
  酸奶: "dairy",
  酸奶油: "dairy",
  酸奶饮品: "other",
  酸枣: "fruit",
  酸浆: "fruit",
  酸菜: "other",
  酸黄瓜: "other",
  醋: "other",
  醋栗: "fruit",
  释迦: "fruit",
  里脊肉: "meat",
  重奶油: "dairy",
  野兔: "meat",
  野山椒: "produce",
  野猪肉: "meat",
  野生蓝莓: "fruit",
  野苏: "produce",
  野香菇: "produce",
  野鸡: "meat",
  野鸭: "meat",
  金丝瓜: "produce",
  金帅苹果: "fruit",
  金杏: "fruit",
  金枕榴莲: "fruit",
  金果猕猴桃: "fruit",
  金枪鱼: "seafood",
  金枪鱼罐头: "other",
  金桔: "fruit",
  金橘: "fruit",
  金煌芒: "fruit",
  金瓜: "produce",
  金线鱼: "seafood",
  金针: "produce",
  金针菇: "produce",
  金针菜: "other",
  金钻凤梨: "fruit",
  金顶侧耳: "produce",
  金顶蘑: "produce",
  金鲳: "seafood",
  钉螺: "seafood",
  铁棍山药: "produce",
  银杏: "fruit",
  银耳: "produce",
  银芽: "produce",
  银针: "produce",
  银鱼: "seafood",
  银鲳: "seafood",
  银鳕鱼: "seafood",
  锥螺: "seafood",
  锦荔枝: "produce",
  锦鲤: "seafood",
  长条茄: "produce",
  长竹蛏: "seafood",
  长茄子: "produce",
  长豆芽: "produce",
  长豆角: "produce",
  长黄瓜: "produce",
  阳光玫瑰葡萄: "fruit",
  阿克苏苹果: "fruit",
  阿根廷红虾: "seafood",
  陈醋: "other",
  镇江醋: "other", // Zhenjiang vinegar
  镇江香醋: "other", // Zhenjiang aromatic vinegar (Chinkiang)
  陕西辣椒: "produce",
  隼人瓜: "produce",
  雪梨: "fruit",
  雪灵菇: "produce",
  雪碧: "other",
  雪糕: "other",
  雪耳: "produce",
  雪花梨: "fruit",
  雪莲果: "produce",
  雪菜: "produce", // fresh pickled mustard greens
  雪蟹: "seafood",
  雪里蕻: "produce",
  露地番茄: "produce",
  露地茄子: "produce",
  露地黄瓜: "produce",
  青冬瓜: "produce",
  青南瓜: "produce",
  青口: "seafood",
  青口贝: "seafood",
  青头菌: "produce",
  青头萝卜: "produce",
  青提: "fruit",
  青木瓜: "fruit",
  青枣: "fruit",
  青柠: "fruit",
  青柠檬: "fruit",
  青梅: "fruit",
  青梨: "fruit",
  青椒: "produce",
  青椒秧: "produce",
  青椰子: "fruit",
  青橘: "fruit",
  青毛豆: "produce",
  青瓜: "produce",
  青甘蓝: "produce",
  青皮茄: "produce",
  青石斑: "seafood",
  青稞: "other",
  青紫苏: "produce",
  青腿蘑: "produce",
  青芒: "fruit",
  青芒果: "fruit",
  青花椒: "other",
  青花菜: "produce",
  青花鱼: "seafood",
  青苤蓝: "produce",
  青苦瓜: "produce",
  青茄子: "produce",
  青菜: "produce",
  青萝卜: "produce",
  青蒜: "produce",
  青葱: "produce", // scallion / spring onion
  青虾: "seafood",
  青蚕豆: "produce",
  青蛤: "seafood",
  青蟹: "seafood",
  青豆: "produce",
  青豌豆: "produce",
  青辣椒: "produce",
  青香蕉: "fruit",
  青鱼: "seafood",
  青黄瓜: "produce",
  青龙: "seafood",
  青龙椒: "produce",
  面包: "other",
  面包蟹: "seafood",
  面条: "other",
  面条瓜: "produce",
  面粉: "other",
  鞭笋: "produce",
  韩国年糕: "other",
  韩国泡菜: "other",
  韩国辣椒: "produce",
  韩国辣椒酱: "other", // gochujang
  韩式辣酱: "other", // gochujang
  韩式辣椒酱: "other", // gochujang
  苦椒酱: "other", // gochujang
  韭菜: "produce",
  韭菜猪肉馅: "meat",
  韭菜花: "produce",
  韭菜苔: "produce",
  韭菜饺子: "other",
  韭葱: "produce",
  韭黄: "produce",
  章姬草莓: "fruit",
  章鱼: "seafood",
  章鱼头: "seafood",
  章鱼足: "seafood",
  顶花黄瓜: "produce",
  顺黄瓜: "produce",
  风味酸奶: "dairy",
  飞蟹: "seafood",
  飞鱼籽: "seafood",
  食用油: "other",
  食用芦荟: "produce",
  食盐: "other",
  餐包: "other",
  饮料: "other",
  饺子: "other",
  饼干: "other",
  馄饨: "other",
  馒头: "other",
  香印葡萄: "fruit",
  香叶: "other",
  香干: "other",
  香梨: "fruit",
  香椿: "produce",
  香椿头: "produce",
  香椿芽: "produce",
  香椿芽苗: "produce",
  香椿苗: "produce",
  香水柠檬: "fruit",
  香水菠萝: "fruit",
  香油: "other",
  香瓜: "fruit",
  香米: "other",
  香肠: "meat",
  香芋: "produce",
  香芹: "produce",
  香茅: "produce",
  香菇: "produce",
  香菜: "produce",
  香菜根: "produce",
  香菜梗: "produce",
  香菜籽: "other", // coriander seeds (spice)
  香葱: "produce",
  香蕉: "fruit",
  香蕉干: "other",
  香蕉片: "other",
  香螺: "seafood",
  香醋: "other",
  香脂醋: "other", // balsamic vinegar
  马兰头: "produce",
  马卡龙: "other",
  马奶葡萄: "fruit",
  马肉: "meat",
  马芬: "other",
  马苏里拉: "dairy",
  马苏里拉奶酪: "dairy",
  马萨拉: "other",
  马蹄: "produce",
  马郁兰: "produce",
  马铃薯: "produce",
  马鲛鱼: "seafood",
  马齿苋: "produce",
  驴肉: "meat",
  骆驼肉: "meat",
  高筋面粉: "other",
  高粱: "other",
  高良姜: "produce",
  高茄子: "produce",
  高达奶酪: "dairy",
  魔芋: "produce",
  魔芋豆腐: "other",
  鮟鱇鱼: "seafood",
  鱼: "seafood",
  鱼丸: "other",
  鱼卵: "seafood",
  鱼块: "seafood",
  鱼头: "seafood",
  鱼子酱: "other",
  鱼尾: "seafood",
  鱼排: "seafood",
  鱼柳: "seafood",
  鱼泡: "seafood",
  鱼片: "seafood",
  鱼皮: "seafood",
  鱼籽: "seafood",
  鱼糜: "seafood",
  鱼肉: "seafood",
  鱼肚: "seafood",
  鱼腥草: "produce",
  鱼豆腐: "other",
  鱼露: "other",
  鱼饼: "other",
  鱼骨: "seafood",
  鱼鳔: "seafood",
  鱼鳞草: "produce",
  鱿鱼: "seafood",
  鱿鱼圈: "seafood",
  鱿鱼干: "seafood",
  鱿鱼筒: "seafood",
  鱿鱼身: "seafood",
  鱿鱼须: "seafood",
  鲀鱼: "seafood",
  鲂鱼: "seafood",
  鲅鱼: "seafood",
  鲈鱼: "seafood",
  鲈鱼片: "seafood",
  鲍鱼: "seafood",
  鲍鱼仔: "seafood",
  鲑鱼: "seafood",
  鲜奶: "dairy",
  鲜奶油: "dairy",
  鲜枣: "fruit",
  鲜虾: "seafood",
  鲜蚕豆: "produce",
  鲜香菇: "produce",
  鲜黄花菜: "produce",
  鲢鱼: "seafood",
  鲤鱼: "seafood",
  鲨鱼: "seafood",
  鲫鱼: "seafood",
  鲭鱼: "seafood",
  鲳扁鱼: "seafood",
  鲳鱼: "seafood",
  鲶鱼: "seafood",
  鲷鱼: "seafood",
  鲽鱼: "seafood",
  鳄梨: "fruit",
  鳊鱼: "seafood",
  鳎目鱼: "seafood",
  鳐鱼: "seafood",
  鳕鱼: "seafood",
  鳕鱼块: "seafood",
  鳕鱼片: "seafood",
  鳖: "seafood",
  鳗鱼: "seafood",
  鳜鱼: "seafood",
  鳜鱼片: "seafood",
  鳟鱼: "seafood",
  鳢鱼: "seafood",
  鸟贝: "seafood",
  鸡: "meat",
  鸡全翅: "meat",
  鸡大腿: "meat",
  鸡头: "meat",
  鸡小腿: "meat",
  鸡屁股: "meat",
  鸡心: "meat",
  鸡心椒: "produce",
  鸡枞菌: "produce",
  鸡架: "meat",
  鸡柳: "meat",
  鸡油菌: "produce",
  鸡爪: "meat",
  鸡精: "other",
  鸡翅: "meat",
  鸡翅中: "meat",
  鸡翅尖: "meat",
  鸡翅根: "meat",
  鸡翅膀: "meat",
  鸡肉: "meat",
  鸡肉丁: "meat",
  鸡肉丝: "meat",
  鸡肉片: "meat",
  鸡肉馅: "meat",
  鸡肝: "meat",
  鸡肠: "meat",
  鸡肫: "meat",
  鸡胗: "meat",
  鸡胸: "meat",
  鸡胸肉: "meat",
  鸡胸脯: "meat",
  鸡脖: "meat",
  鸡腿: "meat",
  鸡腿肉: "meat",
  鸡腿菇: "produce",
  鸡蛋: "dairy",
  鸡蛋白: "dairy",
  鸡蛋芒: "fruit",
  鸡蛋茄: "produce",
  鸡蛋豆腐: "other",
  鸡蛋面: "other",
  鸡血: "meat",
  鸡骨架: "meat",
  鸭: "meat",
  鸭头: "meat",
  鸭屁股: "meat",
  鸭心: "meat",
  鸭掌: "meat",
  鸭架: "meat",
  鸭梨: "fruit",
  鸭翅: "meat",
  鸭肉: "meat",
  鸭肝: "meat",
  鸭肠: "meat",
  鸭胗: "meat",
  鸭胸: "meat",
  鸭胸肉: "meat",
  鸭腿: "meat",
  鸭腿肉: "meat",
  鸭舌: "meat",
  鸭蛋: "dairy",
  鸭血: "meat",
  鸭骨架: "meat",
  鸽子: "meat",
  鸽子肉: "meat", // pigeon meat
  鸽子蛋: "dairy",
  鸿喜菇: "produce",
  鹅: "meat",
  鹅掌: "meat",
  鹅肉: "meat",
  鹅肝: "meat",
  鹅腿: "meat",
  鹅蛋: "dairy",
  鹅蛋茄: "produce",
  鹌鹑: "meat",
  鹌鹑肉: "meat",
  鹌鹑蛋: "dairy",
  鹰嘴豆: "other",
  鹰嘴豆罐头: "other",
  鹿肉: "meat",
  鹿角菜: "produce",
  麒麟果: "fruit",
  麒麟瓜: "fruit",
  麦片: "other",
  麻小: "seafood",
  麻椒: "other",
  麻油: "other",
  麻辣烫底料: "other",
  黄元帅: "fruit",
  黄咖喱: "other",
  黄哈密瓜: "fruit",
  黄土豆: "produce",
  黄圣女: "fruit",
  黄圣女果: "produce",
  黄姑鱼: "seafood",
  黄姜: "produce",
  黄心猕猴桃: "fruit",
  黄心薯: "produce",
  黄木瓜: "fruit",
  黄李: "fruit",
  黄枇杷: "fruit",
  黄柠檬: "fruit",
  黄桃: "fruit",
  黄桃罐头: "other",
  黄桃酸奶: "dairy",
  黄椒: "produce",
  黄樱桃: "fruit",
  黄油: "dairy",
  黄洋葱: "produce",
  黄玉米: "produce",
  黄玛瑙: "fruit",
  黄瓜: "produce",
  黄瓜丁: "produce",
  黄瓜丝: "produce",
  黄瓜条: "produce",
  黄瓜段: "produce",
  黄瓜片: "produce",
  黄瓜秧: "produce",
  黄瓜花: "produce",
  黄瓜苗: "produce",
  黄瓤西瓜: "fruit",
  黄甘蓝: "produce",
  黄番茄: "produce",
  黄皮火龙果: "fruit",
  黄秋葵: "produce",
  黄米: "other",
  黄糖: "other",
  黄肉桃: "fruit",
  黄花: "other",
  黄花菜: "produce",
  黄花鱼: "seafood",
  黄蘑: "produce",
  黄豆: "other",
  黄豆芽: "produce",
  黄豆酱: "other",
  黄酒: "other",
  黄金凤梨: "fruit",
  黄金针菇: "produce",
  黄香蕉: "fruit",
  黄鱼: "seafood",
  黄鳍金枪鱼: "seafood",
  黄鳝: "seafood",
  黄黄瓜: "produce",
  黑加仑: "fruit",
  黑叶荔枝: "fruit",
  黑圣女果: "produce",
  黑布林: "fruit",
  黑提: "fruit",
  黑木耳: "produce",
  黑松露: "produce",
  黑树莓: "fruit",
  黑桑葚: "fruit",
  黑椒: "produce",
  黑樱桃: "fruit",
  黑毛豆: "produce",
  黑炭杨梅: "fruit",
  黑番茄: "produce",
  黑皮冬瓜: "produce",
  黑米: "other",
  黑美人西瓜: "fruit",
  黑胡椒: "other",
  黑芝麻: "other",
  黑醋: "other", // chinkiang/Chinese black vinegar
  黑茄子: "produce",
  黑莓: "fruit",
  黑莓酱: "other",
  黑豆: "other",
  黑豆芽: "produce",
  黑面包: "other",
  黑鱼: "seafood",
  黑鲈鱼: "seafood",
  黑鲳: "seafood",
  墨斗鱼: "seafood",
  墨西哥牛油果: "fruit",
  墨西哥辣椒: "produce",
  墨鱼: "seafood",
  墨鱼丸: "other",
  墨鱼仔: "seafood",
  墨鱼干: "seafood",
  鼠尾草: "produce",
  龙利鱼: "seafood",
  龙口粉丝: "other",
  龙眼: "fruit",
  龙眼干: "other",
  龙眼葡萄: "fruit",
  龙蒿: "produce",
  龙虾: "seafood",
  龙虾尾: "seafood",
  龙虾肉: "seafood",
  龙虾钳: "seafood",
  龙须菜: "produce",
  龙须豆: "produce",
  海米: "seafood",
  瑶柱: "seafood",
  花胶: "seafood",
  韩式辣白菜: "other",
  朝鲜辣白菜: "other",
  袖珍菇: "produce",
  榛蘑: "produce",
  大枣: "other",
  新疆红枣: "other",
  和田大枣: "other",
  若羌枣: "other",
  黑枣: "other",
  桂圆肉: "other",
  枸杞叶: "produce",
  毛蛤: "seafood",
};
